import { useContext } from 'react';
import { CatalogContext } from '../../providers/catalog-context';
import { CatalogUseCases } from '../../../main/factories/catalog-dependencies.factory';

export const useCatalog = (): CatalogUseCases => {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error('useCatalog debe ser utilizado dentro de un CatalogProvider');
  }
  return context;
};
